import { Component } from '@angular/core';

import { SubMenuOption } from '../types/submenu-option';

@Component({
  selector: 'hubs-sub-menu',
  template: `<sub-menu [options]="subMenu"></sub-menu>`,
})


export class HubsSubMenuComponent {
  subMenu: SubMenuOption[];

  constructor() {
    this.subMenu = [
      { route: '/hubs/all', title: 'All Hubs' },
      { route: '/hubs/new', title: 'New Hubs' },
      { route: '/hubs/problems', title: 'Problems' },
      { route: '/hubs/wire_mode_changed', title: 'Wires Changed' },
      { route: '/glitches', title: 'Glitches' },
      { route: '/hubs/reboots', title: 'Reboots' },
    ];
  }
}
